import Vue from 'vue';
import { mapGetters } from 'vuex';
import Auth from 'src/api/auth';
import Paginator from 'components/widgets/Paginator.vue';
import FormatUtils from 'src/utils/formatters';
export default Vue.extend({
    components: { Paginator },
    data() {
        return {
            users: {},
            pageNumber: 1
        };
    },
    computed: {
        ...mapGetters([
            'loggedIn', 'isAdmin', 'isSubscribed', 'currentUser', 'projects'
        ]),
        pageCount() {
            return Math.ceil(this.users.count / 10);
        }
    },
    mounted() {
        this.getUsers(1);
    },
    methods: {
        date: FormatUtils.date,
        getUsers(pageNumber) {
            Auth.getUserListPaginate(pageNumber)
                .then((response) => {
                this.users = response;
                this.pageNumber = pageNumber;
            });
        }
    }
});
